import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Incidencia } from "../../../models/incidencia";
import { AlbaranService } from "../../../services/albaran.service";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { UploadService } from "../../../services/upload.service";
import { Checklist } from "../../../models/checklist";
import { AlbaranProgressComponent } from "../albaran-progress/albaran-progress.component";
import { ConnectionService } from "../../../services/connection.service";

@Component({
    selector: 'app-albaran-progress-new-incidencia',
    templateUrl: './albaran-progress-new-incidencia.component.html',
    styleUrls: ['./albaran-progress-new-incidencia.component.scss'],
    standalone: false
})
export class AlbaranProgressNewIncidenciaComponent {

    @Input() newIncidencia: Checklist = new Checklist();
    @Input() idTransport: any;
    @Input() ididAlbara: any;
    @ViewChild('buttonModal') buttonModal!: ElementRef;
    @ViewChild('fotoInput') fotoInput!: ElementRef<HTMLInputElement>;

    base64image: any;
    file: any;

    incidencia: Incidencia = new Incidencia();

    boolSendIncidencia: boolean = false;
    buttonHidden: boolean = true;

    showAlertSuccessUploadPhotoIncidencia: boolean = false;
    messageSuccessIncidencia: string = "";
    showAlertErrorUploadPhotoIncidencia: boolean = false;
    messageErrorIncidencia: string = "";

    showAlertSendIncidencia: boolean = false;
    messageSendIncidencia: string = "";

    constructor(
        private albaranService: AlbaranService,
        private route: ActivatedRoute,
        private location: Location,
        private uploadService: UploadService,
        private albaranProgress: AlbaranProgressComponent,
        private connection: ConnectionService
    ) {
    }

    previewImage(event: Event) {
        let input = event.target as HTMLInputElement;

        // @ts-ignore
        this.file = input.files[0];
        const reader = new FileReader();

        reader.onload = (e: any) => {
            const imagePreviewUrl = e.target.result;
            this.base64image = imagePreviewUrl.split(',')[1];
        };

        reader.readAsDataURL(this.file);
        this.resetInput();

        this.buttonModal.nativeElement.click();
    }

    uploadFotoIncidencia() {
        this.albaranProgress.showLoader = true;

        this.uploadService.uploadFileIncidencia(this.file, this.ididAlbara, "incidencia").subscribe(
            {
                next: next => {
                    this.showAlertSuccessUploadPhotoIncidencia = !this.showAlertSuccessUploadPhotoIncidencia;
                    this.messageSuccessIncidencia = next.message;
                    this.boolSendIncidencia = true;
                    this.albaranProgress.showLoader = false;
                }, error: error => {
                    this.showAlertErrorUploadPhotoIncidencia = !this.showAlertErrorUploadPhotoIncidencia;
                    this.messageErrorIncidencia = this.connection.reportError(error) ? "Sin conexión: no se ha podido guardar. Inténtalo de nuevo cuando recuperes cobertura." : (error.error?.message ?? "No se ha podido completar la operación.");
                    this.albaranProgress.showLoader = false;
                }
            }
        );
    }

    closeAlertSuccessIncidencia() {
        this.showAlertSuccessUploadPhotoIncidencia = !this.showAlertSuccessUploadPhotoIncidencia;
    }

    closeAlertErrorIncidencia() {
        this.showAlertErrorUploadPhotoIncidencia = !this.showAlertErrorUploadPhotoIncidencia;
    }

    private resetInput() {
        // Permite volver a elegir el mismo archivo tras un fallo
        this.fotoInput.nativeElement.value = '';
    }

    sendIncidencia(idCheck: any, idLloc: any) {
        this.incidencia.lloc = idLloc;
        this.albaranProgress.showLoader = true;

        this.albaranService.sendIncidencia(this.incidencia, this.ididAlbara, this.idTransport, idCheck).subscribe(
            {
                next: next => {
                    this.showAlertSendIncidencia = !this.showAlertSendIncidencia;
                    this.messageSendIncidencia = next.message;
                    this.albaranProgress.showLoader = false;
                },
                error: error => {
                    this.showAlertSendIncidencia = !this.showAlertSendIncidencia;
                    this.messageSendIncidencia = this.connection.reportError(error) ? "Sin conexión: no se ha podido guardar. Inténtalo de nuevo cuando recuperes cobertura." : (error.error?.message ?? "No se ha podido enviar la incidencia.");
                    this.albaranProgress.showLoader = false;
                }
            }
        )
    }

    async closeAlertSendIncidencia() {
        this.showAlertSendIncidencia = !this.showAlertSendIncidencia;
        await this.albaranProgress.reload();
    }

}
